// IMPORT LIBS
import jQuery from 'jquery';
import Swiper from 'swiper';
import noUiSlider from 'nouislider';
import bootstrapBundle from 'bootstrap/dist/js/bootstrap.bundle';
import "regenerator-runtime/runtime";


window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.noUiSlider = noUiSlider;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('@fancyapps/fancybox');
window.fancybox = fancybox;

// IMPORT CLASSES
import Used from './classes/Used';

// IMPORT FUNCTIONS
import { swipersInit } from './functions/sliders';
import { showPartialsFixed } from './functions/partialsFixed';
import { redirectPage } from './functions/redirectPage';
import { sidebarFixedBehavior } from './functions/sidebarFixed';
import { handleSetMoreHeight } from './functions/setHeights';
import { accordionsCreate } from './functions/accordions';
import { chooseUnits } from './functions/chooseLocation';
import { setCustomListener } from './functions/actionsForm';
import { buttonCotationBehavior, buttonFilterBehavior } from './functions/actionsForm';

document.addEventListener('DOMContentLoaded', function() {

  // INIT LAZY LOADING
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // FUNCTION TO CONTROL HEADER/FOOTER FIXED
  window.addEventListener('scroll', () => {
    showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
  });

 // FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
 buttonCotationBehavior('.button-call-form');

  // FUNCTION TO CONTROL BEHAVIOR OF SIDEBAR FIXED
  sidebarFixedBehavior('.js-sidebar-button');

    // FUNCTION TO INIT CHOOSE LOCATION
    chooseUnits();

  // FUNCTION TO UP TOP PAGE
  $('.btn-scroll-top').on('click', function () {
    $('html,body').animate({ scrollTop: 0 }, '300')
  });

  setTimeout(() => {
    // FUNCTION TO SET MORE HEIGHT AMONG THE ELEMENTS OF SAME TYPE
    handleSetMoreHeight('.js-service-name', 992);
    handleSetMoreHeight('.js-service-description', 992);
  }, 500);

  accordionsCreate();
  
  // FUNCTION TO REDIRECT TO HOME PAGE
  redirectPage();

  const marcaSelects = document.querySelectorAll(".brand");
  const selectStoreElement = document.querySelectorAll('select.store');
  const departmentSelectElements = [];
  departmentSelectElements.push(...document.querySelectorAll('.departments-home'));
  departmentSelectElements.push(...document.querySelectorAll('[name="departamento"]'));

  const allStoresUnits = getOptionsWithDataBrand();

  renderOptionsByBrand();

  // Função para coletar opções e evitar duplicatas
  function getOptionsWithDataBrand() {
    const optionsArray = [];
    const uniqueElements = new Set();

    selectStoreElement.forEach(select => {
      select.querySelectorAll('option').forEach(option => {
        let brand = option.getAttribute('data-brand');

        if (!brand) {
          brand = option.textContent.trim();
        }

        // Normaliza o conteúdo do HTML e remove todos os espaços extras
        const optionHTML = option.outerHTML.replace(/\s+/g, ' ').trim();
        const normalizedTextContent = option.textContent.replace(/\s+/g, ' ').trim();
        const identifier = `${brand}-${option.value}-${normalizedTextContent}`;

        if (!uniqueElements.has(identifier)) {
          uniqueElements.add(identifier);
          optionsArray.push({
            brand: brand,
            element: optionHTML
          });
        }
      });
    });

    return optionsArray;
  }

  function renderOptionsByBrand() {

    let options = []
    let showSupercenter = false;
    let selectedBrand = '';

    // Verifica se é necessário exibir a opção de Supercenter
    departmentSelectElements.forEach(function (departmentSelect) {
      const departmentValue = departmentSelect.value;
      if (departmentValue === "Assistência Técnica" || departmentValue === "assistencia-tecnica" || departmentValue === "SAC" || departmentValue === "servicos" ) {
        showSupercenter = allStoresUnits.find(store => store.brand === 'Supercenter') ? true : false;
      }
    })

    marcaSelects.forEach(function (marcaSelect) {
      if (marcaSelect.value) {

        // verifica se a marca selecionada está no array de opções
        const selectedOption = allStoresUnits.find(store => store.brand === marcaSelect.value);
        if (selectedOption) {
          selectedBrand = selectedOption.brand;
        }
      }
    });

    // Montar array de opções

    const meioCaptacao = document.querySelector('input[name="meio_captacao"]');

    if(meioCaptacao && meioCaptacao.value === 'form-site-assistencia-tecnica') {
      // Add "Selecione uma unidade*" as first option to options array if services page
      options.push(allStoresUnits.find(store => store.brand === 'Selecione uma unidade*').element);
    } else {
      // Add "Loja*" as first option to options array
      options.push(allStoresUnits.find(store => store.brand === 'Loja*').element);
    }

    // Add supercenter option to options array
    if (showSupercenter) {
      options.push(allStoresUnits.find(store => store.brand === 'Supercenter').element);
    }

    // Add selected brand options to options array. If no brand is selected, add all options with dynamic-store class
    if (selectedBrand !== '') {
      options.push(...allStoresUnits.filter(store => store.brand === selectedBrand).map(store => store.element));
    } else {
      options.push(...allStoresUnits.filter(store => store.element.includes('dynamic-store')).map(store => store.element));
    }

    // Render options
    selectStoreElement.forEach(select => {
      select.innerHTML = options.join('');
    });

  }

  // Listener para mudanças no select de departamentos
  departmentSelectElements.forEach(function (departmentSelect) {
    departmentSelect.addEventListener("change", function () {
      renderOptionsByBrand();
    });
  })

  // Listener para mudanças no select de marcas
  marcaSelects.forEach(function (marcaSelect) {
    marcaSelect.addEventListener("change", function () {
      renderOptionsByBrand();
    });
  });

    var formElements = document.querySelectorAll('.custom-form');

    formElements.forEach(function (formElement) {
      var selectElement = formElement.querySelector('.form-input.departments-home');
      var modeloElement = formElement.querySelector('.modelo-home');
      var areaDeSacElement = formElement.querySelector('.sac-home');

      selectElement.addEventListener('change', function () {
        var selectedValue = selectElement.value;

        if (selectedValue === 'SAC' && areaDeSacElement) {
          modeloElement.style.display = 'none';
          areaDeSacElement.style.display = 'flex';
        } else {
          modeloElement.style.display = 'flex';
          areaDeSacElement.style.display = 'none';
        }
      });
    });


});

// FUNCTION TO ADD OVERLAY ON MODALS
function popUp(selector) {
  $('body,html').addClass('scroll-lock');
  selector.fadeIn('fast');
}

function popClose(form) {
  form ? $('.modal-form').fadeOut() : $('.modal-overlay').fadeOut();
  $('body,html').removeClass('scroll-lock');
}

$('.btn-open-modal').on('click', function () {
  const el = $(this).data('target');
  const data = $(this).data('json');
  data ? modalInject(data, el) : popUp($(el));
})

// FUNCTION TO OPEN MODALS
$('.modal-overlay, .btn-close-modal').on('click', function (e) {
  $(e.target).hasClass('form-close') ? popClose(true) : popClose()
}).on('click', '.pop-up-content', function (event) {
  event.stopPropagation()
});

// FUNCTION TO CONTROL SELECTS EXHIBITION
setCustomListener();
